import { createSlice } from '@reduxjs/toolkit';

const aiChatbotSlice = createSlice({
  name: 'aiChatbot',
  initialState: {
    isVoiceAssistantOpen: false,
    isMicOn: false,
    thread_id: null,
  },
  reducers: {
    openVoiceAssistant(state) {
      state.isVoiceAssistantOpen = true;
    },
    closeVoiceAssistant(state) {
      state.isVoiceAssistantOpen = false;
    },
    setVoiceAssistantOpen(state, action) {
      state.isVoiceAssistantOpen = action.payload;
    },
    setMicOn(state) {
      state.isMicOn = true;
    },
    setMicOff(state) {
      state.isMicOn = false;
    },
    toggleMic(state) {
      state.isMicOn = !state.isMicOn;
    },
    setThreadId(state, action) {
      state.thread_id = action.payload;
    },
  },
});

export const { openVoiceAssistant, closeVoiceAssistant, setVoiceAssistantOpen, setMicOff, setMicOn, toggleMic, setThreadId  } = aiChatbotSlice.actions;
export default aiChatbotSlice.reducer;